var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8CAEB4",
    d: "M13.544 2.457H10.78v-.735c0-.931-.757-1.689-1.689-1.689H6.287c-.932 0-1.69.758-1.69 1.69v.734H1.833C.828 2.457.01 3.275.01 4.28v7.683c0 1.006.818 1.824 1.824 1.824h11.71c1.005 0 1.823-.818 1.823-1.824V4.28c0-1.005-.818-1.823-1.823-1.823zm-7.732-.735c0-.261.213-.474.475-.474h2.805c.26 0 .473.213.473.474v.735H5.812v-.735zm-3.978 1.95h11.71c.335 0 .608.273.608.608v2.261H1.226v-2.26c0-.336.273-.608.608-.608zm5.149 4.085h1.412v1.32H6.983v-1.32zm6.56 4.814H1.834c-.334 0-.607-.273-.607-.608V7.757h4.541v1.566c0 .535.436.97.97.97h1.904c.535 0 .97-.435.97-.97V7.757h4.54v4.206c.001.335-.272.608-.607.608z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/staff-icon.7f6b8625a62fd73f5ba04e408967f115.svg";
export { ForwardRef as ReactComponent };